import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakService } from '@core-services';
import { KeycloakRole } from '@shared-enums';
import { KeycloakTokenParsed } from 'keycloak-js';

export const keycloakGuard: CanActivateFn = (route, state) => {
  const keycloakService = inject(KeycloakService);
  const router = inject(Router);
  if (keycloakService.keycloak.isTokenExpired()) {
    router.navigateByUrl('/todo');
    return false;
  } else {
    const tokenParsed = keycloakService.keycloak.tokenParsed as
      | KeycloakTokenParsed
      | { resource_access: ResourceAccess };
    const clientRoles = tokenParsed.resource_access!['employeesSunbeds']?.roles || [];
    if (
      clientRoles.includes(KeycloakRole.Sunbeds) ||
      !!tokenParsed.resource_access?.['realm-management']
    ) {
      return true;
    } else {
      keycloakService.logout();
      return false;
    }
  }
};

interface ResourceAccess {
  'isbp-employees-bike'?: {
    roles: string[];
  };
  employeesSunbeds?: {
    roles: string[];
  };
  'realm-management'?: {
    roles: string[];
  };
}
